/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API Exporter
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Export format
 * @export
 * @enum {string}
 */

export const ExportFormats = {
    Yml: 'YML',
    Xml: 'XML',
    InSales: 'InSales',
    Csv: 'CSV',
    Json: 'JSON',
    SimpleJson: 'Simple JSON',
    TgShop: 'TgShop',
    Tilda: 'Tilda',
    WooCommerce: 'WooCommerce',
    PriceFormatter: 'PriceFormatter',
    Avito: 'Avito'
} as const;

export type ExportFormats = typeof ExportFormats[keyof typeof ExportFormats];



